import { render, staticRenderFns } from "./review-status.vue?vue&type=template&id=c2fafd6c"
import script from "./review-status.vue?vue&type=script&lang=ts"
export * from "./review-status.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports